import React from 'react'
import { Collapse, Stack } from 'react-bootstrap'
import { CollapseControl, HorizontalStack, Icon, JsonViewer, ShowIf } from '@ztechapps/webui.util'
import { LocalDateTime } from '@ztechapps/webui.date'
import type { History } from '@ztechapps/common.contract'
import type { BodyRowConfig } from '../../DataTable/types'
import { RowNumberBodyCell } from '../../DataTable/table-body/RowNumberBodyCell'

export const TableRow = (props: BodyRowConfig<History>) => {
  const { timeStamp, description, diff, author, entity, entityKey } = props
  const [showDiff, setShowDiff] = React.useState(false)

  const handleShowDiff = () => {
    setShowDiff(!showDiff)
  }

  return (
    <>
      <RowNumberBodyCell {...props} />

      {props._renderDataBodyCell({
        timeStamp: (
          <Stack gap={1}>
            <HorizontalStack gap={3}>
              <div>
                <Icon name="calendar" title="The date and time the changes happens" />{' '}
                <LocalDateTime value={timeStamp} timeZone={''} />
              </div>
              <div>
                <Icon name="user" title="Change by this person" /> {author}
              </div>
            </HorizontalStack>
            <HorizontalStack gap={2}>
              <div>
                {diff && (
                  <CollapseControl
                    iconHide="chevron-circle-up"
                    iconShow="chevron-circle-down"
                    show={showDiff}
                    setShow={handleShowDiff}
                    title="Click this to toggle showing of differential."
                  />
                )}
              </div>
              <strong>{entity}</strong> {entityKey} - {description}
            </HorizontalStack>

            <ShowIf condition={!!diff}>
              <Collapse in={showDiff}>
                <div>
                  <JsonViewer data={diff} collapsed={false} />
                </div>
              </Collapse>
            </ShowIf>
          </Stack>
        ),
      })}
    </>
  )
}
